module.exports = __webpack_public_path__ + "img/on-topic.75a7ea01.png";